import type { IPxocChatItem } from './machine/types';

// Presumably this info should come from API eventually
export const generateConclusionReasons = (chatList: IPxocChatItem[], conditionName?: string) => {
  const reasons: string[] = [];
  chatList.forEach((chatItem) => {
    if (!Array.isArray(chatItem.answer)) {
      return;
    }
    chatItem.answer?.forEach((ans) => {
      if (ans.conclusionReason) {
        reasons.push(ans.conclusionReason);
      }
    });
  });

  if (conditionName) {
    reasons.push(`Addresses ${conditionName}`);
  }

  return reasons;
};
